import { render, staticRenderFns } from "./studentinformation.vue?vue&type=template&id=1e06391b&scoped=true"
import script from "./studentinformation.vue?vue&type=script&lang=js"
export * from "./studentinformation.vue?vue&type=script&lang=js"
import style0 from "./studentinformation.vue?vue&type=style&index=0&id=1e06391b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e06391b",
  null
  
)

export default component.exports